var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-parallax-img"},[_c('app-parallax',{attrs:{"power":0.1,"transform":"scale(1.1) translateZ(0)"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }